import { createFileRoute, redirect } from '@tanstack/react-router';

// EPIC-06: rota consolidada em /sorteios?tab=pendentes. Mantida pra backward compat de bookmarks.
export const Route = createFileRoute('/_admin/sorteios/pendentes')({
  beforeLoad: () => {
    throw redirect({ to: '/sorteios', search: { tab: 'pendentes' }, replace: true });
  },
});
